import { Component, ChangeDetectionStrategy } from '@angular/core';


@Component({
	selector: 'experience-ai-advisor-tab-2-part',
	standalone: true,
	templateUrl: './experience-ai-advisor-tab-2.part.html',
	changeDetection: ChangeDetectionStrategy.Eager,
	styleUrls: [`./experience-ai-advisor-tab-2.part.scss`],
})
export class ExperienceAIAdvisorTab2Part {
}
